// extracted by mini-css-extract-plugin
export default {"title":"Dialog_title__wPVeD","noOnClose":"Dialog_noOnClose__0N9bm","pageMessage":"Dialog_pageMessage__11ZIb","loader":"Dialog_loader__ZLXC+"};